export default "__VITE_ASSET__DkLil2I7__"